import {
  getDeployEnv,
  getDynamicConfig as getDynamicConfigStore,
  getServeConfig,
  getPlatform,
} from "@/stores/useEnvConfigStore";
import type { DynamicConfig } from "./lookup.type";
import urlJoin from "url-join";
import CryptoJS from "crypto-js";
import { getResourceEndpoint } from "@/stores/useNativeStore";

const getBranch = () => {
  const buildEnv = getDeployEnv();
  const { area } = getServeConfig();

  if (buildEnv === "prod") {
    return area.toLowerCase();
  }

  return buildEnv.toLowerCase();
};

const getDynamicConfig = async () => {
  const branch = getBranch();

  try {
    const isMobile = getPlatform() === "mobile";

    const host = isMobile ? getResourceEndpoint() : "/";
    const { path, aesKey, aesIv } = getDynamicConfigStore();
    const url = urlJoin(host, "/remote-configs", path);

    const raw = await fetch(url);
    const data = await raw.text();
    const dynamicConfig = decryptAESCBC(data, aesKey, aesIv) as DynamicConfig;

    return dynamicConfig;
  } catch (e) {
    console.error(`[Dynamic Config] ${branch} error:`, e);
    throw e;
  }
};

function decryptAESCBC(cipherBase64: string, keyStr: string, ivStr: string) {
  try {
    const decrypted = CryptoJS.AES.decrypt(cipherBase64, CryptoJS.enc.Utf8.parse(keyStr), {
      iv: CryptoJS.enc.Utf8.parse(ivStr),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  } catch {
    return undefined;
  }
}

export default getDynamicConfig;
